import { rpcClient } from 'src/api/rpc/client';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useToast } from 'src/context/ToastContext';
import {
  BulkRetriggerEmailRulesInput,
  PreviewBulkRetriggerEmailRulesInput,
} from '@erp/rpc';

export function useBulkRetriggerEmailRules() {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: async ({
      startDate,
      endDate,
      ruleIds,
    }: BulkRetriggerEmailRulesInput) => {
      return rpcClient.communications.inboundEmails.bulkRetriggerEmailRules({
        startDate,
        endDate,
        ruleIds,
      });
    },
    onSuccess: (data) => {
      showToast({
        title: 'Email Rules Retriggered',
        message:
          data.message || `Queued ${data.emailsQueued} emails for processing`,
        color: 'success',
        icon: 'check_circle',
      });
    },
    onError: (error) => {
      console.error('Failed to bulk retrigger email rules:', error);
      showToast({
        title: 'Failed to Retrigger',
        message:
          error instanceof Error
            ? error.message
            : 'Failed to bulk retrigger email rules',
        color: 'error',
        icon: 'error',
      });
    },
  });
}

export function usePreviewBulkRetriggerEmailRules(
  input: PreviewBulkRetriggerEmailRulesInput | null,
) {
  return useQuery({
    queryKey: [
      'previewBulkRetriggerEmailRules',
      input?.startDate,
      input?.endDate,
      input?.ruleIds,
    ],
    queryFn: async () => {
      if (!input) {
        return { emailCount: 0 };
      }
      return rpcClient.communications.inboundEmails.previewBulkRetriggerEmailRules(
        input,
      );
    },
    enabled: !!input?.startDate && !!input?.endDate,
  });
}
